import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-675c5024")

_pushScopeId("data-v-675c5024")
const _hoisted_1 = { class: "dt-open-api-app-info" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-page-bar" }, [
  /*#__PURE__*/_createVNode("span", { class: "dt-open-api-page-bar-title" }, " 开发配置 ")
], -1)
const _hoisted_3 = { class: "dt-open-api-app-info-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "基础环境", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("td", null, "接口网关", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "https://openapi.iclass30.com", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_8 = /*#__PURE__*/_createVNode("td", null, "appId", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_10 = /*#__PURE__*/_createVNode("td", null, "appSecret", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("复制")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("table", null, [
        _createVNode("tr", null, [
          _hoisted_5,
          _createVNode("td", null, [
            _hoisted_6,
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.copyContent('https://openapi.iclass30.com'))),
              type: "text",
              class: "dt-open-api-app-info-copy-bnt"
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("tr", null, [
          _hoisted_8,
          _createVNode("td", null, [
            _createVNode("span", null, _toDisplayString(_ctx.application.id), 1),
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.copyContent(_ctx.application.id))),
              type: "text",
              class: "dt-open-api-app-info-copy-bnt"
            }, {
              default: _withId(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("tr", null, [
          _hoisted_10,
          _createVNode("td", null, [
            _createVNode("span", null, _toDisplayString(_ctx.application.secret), 1),
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.copyContent(_ctx.application.secret))),
              type: "text",
              class: "dt-open-api-app-info-copy-bnt"
            }, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
})